import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import API_BASE_URL from "../../../constants/api";
interface Category {
  category_id: number;
  category_name: string;
}

interface CategoriesProps {
  onSelect: (categoryId: number) => void;
}

const Categories = ({ onSelect }: CategoriesProps) => {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}categories`)
      .then((res) => setCategories(res.data))
      .catch((err) => console.error('Failed to fetch categories:', err));
  }, []);

  return (
    <div className="blog-widget">
      <h4 className="widget-title">Categories</h4>
      <div className="shop-cat-list">
        <ul className="list-wrap">
          {categories.map((cat) => (
            <li key={cat.category_id}>
              <Link to="#" onClick={() => onSelect(cat.category_id)}>
                <i className="flaticon-angle-right"></i> {cat.category_name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Categories;
